var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpeakerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9165 14.1042V24.8959C9.9165 25.5402 10.4388 26.0626 11.0832 26.0626H18.6665L26.9489 33.1618C27.7057 33.8105 28.8748 33.2727 28.8748 32.276V6.13382C28.8748 5.11513 27.6608 4.58572 26.9143 5.27889L18.6665 12.9376H11.0832C10.4388 12.9376 9.9165 13.4599 9.9165 14.1042ZM36.226 10.8283C35.8665 10.3429 35.1815 10.2409 34.6961 10.6004C34.2107 10.9599 34.1087 11.6449 34.4682 12.1303C35.994 14.1903 36.8959 16.7383 36.8959 19.5001C36.8959 22.262 35.994 24.81 34.4682 26.87C34.1087 27.3554 34.2107 28.0404 34.6961 28.3999C35.1815 28.7594 35.8665 28.6574 36.226 28.172C38.0213 25.7481 39.0834 22.7466 39.0834 19.5001C39.0834 16.2537 38.0213 13.2522 36.226 10.8283ZM33.4827 14.6465C33.1952 14.1153 32.5314 13.9178 32.0002 14.2054C31.469 14.493 31.2715 15.1567 31.559 15.6879C32.1723 16.8207 32.5209 18.1181 32.5209 19.5001C32.5209 20.8822 32.1723 22.1795 31.559 23.3123C31.2715 23.8435 31.469 24.5073 32.0002 24.7949C32.5314 25.0824 33.1952 24.8849 33.4827 24.3537C34.2648 22.909 34.7084 21.2548 34.7084 19.5001C34.7084 17.7455 34.2648 16.0912 33.4827 14.6465Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4598 2L2 37.4598Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4598 2L2 37.4598",
    stroke: "#EE6762",
    strokeWidth: 2.65949,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeakerOff);
export default __webpack_public_path__ + "static/media/icon_speaker_off.3bf77ac1eb0d5c23037b19a92717094d.svg";
export { ForwardRef as ReactComponent };